import { Badge } from 'reactstrap';
const StatusBadge = ({ status, text }) => {
    let statusClass = '';

    if (status === 'new') {
        statusClass = 'secondary';
    } else if (status === 'pending_payment') {
        statusClass = 'info';
    } else if (status === 'payed') {
        statusClass = 'success';
    } else if (status === 'declined') {
        statusClass = 'danger';
    } else {
        statusClass = 'secondary';
    }

    return <Badge color={statusClass}>{text}</Badge>;
};

export default StatusBadge;
